export { default as B2BLoginFormMock } from './login';
